export interface ApiUpdateTaskNameRequest {
    taskId: string;
    content: string;
}

/**
 * 更新任务名称
 */
export interface UpdateTaskNameApi {
    /**
     * 更新任务名称
     * @param data 更新任务名称请求
     */
    updateTaskName(data: ApiUpdateTaskNameRequest): Promise<void>;
}

export const UpdateTaskNameApi = Symbol('UpdateTaskNameApi');

